import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";

export const getProcessingDateCopy = (nextBillingDate: Date, updatedNextBillingDate: Date): string => {
  let baseCopy = typedLocalize(`subscriptions.yourSubscriptions.orderOptionsModal.sendNowView.willBeProcessed`);
  // if current nextBillingDate is equal to updatedNextBillingDate (date that has been adjusted to adhere to org's billing days)
  if (nextBillingDate.valueOf() === updatedNextBillingDate?.valueOf()) {
    baseCopy += typedLocalize(
      "subscriptions.yourSubscriptions.orderOptionsModal.sendNowView.willBeProcessedNextTwentyFourHours"
    );
  } else {
    const formattedDate = typedLocalize("utils.dates.toViewDateLongDay", {
      date: updatedNextBillingDate,
    });
    baseCopy += typedLocalize(
      "subscriptions.yourSubscriptions.orderOptionsModal.sendNowView.willBeProcessedOnDate",
      {
        date: formattedDate,
      }
    );
  }
  return baseCopy;
};
